import React, { memo } from 'react'

import TourV2FAQSection from './TourV2FAQSection'
interface Props {
  faq: Array<Tours.V2OfferFrequentlyAskedQuestion>
}

function TourV2FAQ(props: Props) {
  const { faq } = props

  return (
    <>
      {faq.map((faqSection, index) => (
        <TourV2FAQSection key={index} FAQItem={faqSection} />
      ))}
    </>
  )
}

export default memo(TourV2FAQ)
